import React from "react";
import { FiSlash } from "react-icons/fi";

import { EmployerClosed } from "statics/states";

import "./DisabledCompanyBanner.scss";

interface DisabledCompanyBannerProps {
  /** companyById.currentState. */
  companyState?: string | null;
}

const DisabledCompanyBanner = ({
  companyState,
}: DisabledCompanyBannerProps) => {
  // Disabling an employer moves it to EmployerClosed (see EmployerInfo's
  // Disable/Enable buttons).
  if (companyState !== EmployerClosed) {
    return null;
  }

  return (
    <div className="disabled-company-banner" role="alert">
      <FiSlash
        className="disabled-company-banner-icon"
        size={20}
        aria-hidden="true"
      />
      <p className="disabled-company-banner-message">
        This employer is currently disabled. Its admins and agents have lost
        access.
      </p>
    </div>
  );
};

export default DisabledCompanyBanner;
